export default class RoomService {
  static fromJSON (json) {
    return new RoomService({
      code: json.code,
      name: json.name
    })
  }

  constructor ({ code, name }) {
    this.code = code
    this.name = name
  }
}
